import React, { useEffect, useState } from 'react';
import styles from "../style/BosLandingPage.module.css";
import PieChartBos from './PieChartBos';
import { useHistory } from "react-router-dom";
import { getAllCheckFirmIds } from '../../Common/commondata/commonData';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { landingPageAction } from '../state/actions';
import { Loading } from '../../Common';
import { formatPrice } from '../../DocumentSection/utils/helper';
import BarChartBos from './BarChart';
import { DatePicker, Dropdown, Menu } from 'antd';
import { MoreOutlined } from "@ant-design/icons";

export default function BosLandingPage() {
    const dispatch = useDispatch();
    let labels = [{ value: "Pendings", route: "/pendings", key: "PENDINGS", reducerKey: "pendingsData" }, { value: "Listings", route: "/listings", key: "LISTINGS", reducerKey: "listingsData" }, { value: "Sales", route: "/sales", key: "CURRENT_YEAR_SALES", reducerKey: "currentYearSalesData" }];
    const { allBackOfficeData } = useSelector((state) => state.account);
    const { metricData, metricLoading, metricError } = useSelector((state) => state.landingPageReducer.bosLandingReducer);
    let intitalDateRange = { month: null, quarter: null, year: null, start: undefined, end: undefined };
    const [dateRange, setDateRange] = useState({...intitalDateRange})
    let sourceAxios = axios.CancelToken.source();
    let unmounted = {
        value: false
    };
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    
    useEffect(()=>{
        let firmIds = getAllCheckFirmIds(allBackOfficeData);
        dispatch(landingPageAction.getBosMetricData({queryData: {...(firmIds?.length && {firmIds: firmIds?.join(",")}), dateStringStart: dateRange.start, dateStringEnd: dateRange.end, timezone}, unmounted, sourceAxios}));

        return () => {
            unmounted.value = true;
            sourceAxios.cancel("Cancelling in cleanup");
        };
    }, [allBackOfficeData, dateRange]);

    const handleChange = (pickerType, date) => {
        console.log(date, "datedatedate")
        if (!date) {
            setDateRange(({ ...intitalDateRange, [pickerType]: null }));
            return;
        }
      
        let start, end;
    
        if (pickerType === 'month') {
            start = date.clone().startOf('month').startOf('day');
            end = date.clone().endOf('month').endOf('day');
            console.log(date.clone().format('YYYY-MM-DD'), start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'), "whyyyyyyyyyyyy")
        } else if (pickerType === 'quarter') {
            start = date.clone().startOf('quarter').startOf('day');
            end = date.clone().endOf('quarter').endOf('day');
        } else if (pickerType === 'year') {
            start = date.clone().startOf('year').startOf('day');
            end = date.clone().endOf('year').endOf('day');
        }
      
        setDateRange({
            ...intitalDateRange, 
            [pickerType]: date,
            start: start.format('YYYY-MM-DD'), 
            end: end.format('YYYY-MM-DD')
        })
    }
    return (
        metricLoading ? <Loading /> : metricError ? "something went wrong" : <div>
            <div style={{width: "100%", padding: "2% 0px 15px 0px", display: "flex", justifyContent: "center", gap: "5%"}}>
                <DatePicker picker="month" value={dateRange.month} onChange={(date)=> handleChange("month", date)}/>
                <DatePicker picker="quarter" value={dateRange.quarter} onChange={(date)=> handleChange("quarter", date)}/>
                <DatePicker picker="year" value={dateRange.year} onChange={(date)=> handleChange("year", date)}/>
            </div>
            <div className={styles.bosLandingContainer}>
                {
                    labels?.map((label)=>{
                        return <CommonGrid label={label} metrics={metricData?.[label.reducerKey] || {}}/>
                    })
                }
            </div>
        </div>
    )
}

function CommonGrid({label, metrics}) {
    const { allBackOfficeData } = useSelector((state) => state.account);
    const [optionSelect, setOptionSelect] = useState({
        section: "GRAPH",
        type: "BAR"
    });
    const history = useHistory();
    const handleOptionSelect = (value, type) => {
        setOptionSelect({
            section: value,
            type: type
        });
    }

    const handleRedirect = (label) => {
        history.push(label.route);
    }

    const chartDataFunc = (type) => {
        const pieChartData = [];
        let totalValue = 0;
        for(let i=0 ; i<allBackOfficeData?.length ; i++){
            if(allBackOfficeData[i]?.checked){
                const brokerage = allBackOfficeData[i]?.parentData;
                for(let j=0 ; j<brokerage?.length ; j++){
                    const office = brokerage[j]?.parentData;
                    for(let k=0 ; k<office?.length ; k++){
                        if(office[k]?.checked){
                            let value = metrics?.[office[k]?._id]?.[type] || 0;
                            pieChartData?.push({
                                name: office[k]?.name,
                                backgroundColor: office[k]?.backgroundColor,
                                value,
                                type
                            }) 
                            totalValue += value;
                        }
                    }
                }
                return {totalValue, pieChartData};
            }
        }
        return {};
    }

    const barDataFunc = (type) => {
        const barChartData = [];
        let totalValue = 0;
        for(let i=0 ; i<allBackOfficeData?.length ; i++){
            if(allBackOfficeData[i]?.checked){
                const brokerage = allBackOfficeData[i]?.parentData;
                for(let j=0 ; j<brokerage?.length ; j++){
                    const office = brokerage[j]?.parentData;
                    for(let k=0 ; k<office?.length ; k++){
                        if(office[k]?.checked){
                            let value = metrics?.[office[k]?._id]?.[type] || 0;
                            barChartData?.push({
                                x: k + 1,
                                name: type,
                                color: office[k]?.backgroundColor,
                                y: value
                            }) 
                            totalValue += value;
                        }
                    }
                }
                return {totalValue, barChartData};
            }
        }
        return {};
    }

    const gridDataFunc = () => {
        const gridArray = [];
        for(let i=0 ; i<allBackOfficeData?.length ; i++){
            if(allBackOfficeData[i]?.checked){
                const brokerage = allBackOfficeData[i]?.parentData;
                for(let j=0 ; j<brokerage?.length ; j++){
                    const office = brokerage[j]?.parentData;
                    for(let k=0 ; k<office?.length ; k++){
                        if(office[k]?.checked){
                            gridArray?.push({
                                name: office[k]?.name,
                                values: [
                                    {
                                        name: "Units",
                                        value: metrics?.[office[k]?._id]?.["units"] || 0
                                    },
                                    {
                                        name: "GCI",
                                        value: "$" + (formatPrice({price: metrics?.[office[k]?._id]?.["gci"]}) || 0)
                                    },
                                    {
                                        name: "Volume",
                                        value: "$" + (formatPrice({price: metrics?.[office[k]?._id]?.["volume"]}) || 0)
                                    }
                                ]
                            })
                        }
                    }
                }
                return gridArray;
            }
        }
        return [];
    }

    function MenuBar(){
        return <Menu size="large">
            <Menu.Item
                onClick={() => {setOptionSelect({...optionSelect, type: "BAR"});}}
                key="deleteOfferAndListings"
            >
                <span>Bar</span>
            </Menu.Item>
            <Menu.Item
                onClick={() => {setOptionSelect({...optionSelect, type: "PIE"});}}
                key="changeToActive"
            >
                <span>Pie</span>
            </Menu.Item>
        </Menu>
    }

    return <div className={styles.tabCommon}>
        <div style={{width: "100%"}}>
            <div className={styles.mainButton} onClick={()=>handleRedirect(label)}>{label?.value}</div>
            <div className={styles.compactBox}>
                <div style={{display: "flex"}}>
                    <div onClick={()=>handleOptionSelect("GRAPH", "BAR")} className={styles.optionSelect} style={(optionSelect?.section === "GRAPH") ? {textDecoration: "underline", textUnderlineOffset: "2px"} : {}}>Graph</div>
                    { 
                        (optionSelect?.section === "GRAPH") && <Dropdown overlay={<MenuBar />} trigger={["hover", "click"]}>
                            <MoreOutlined style={{ margin: "4px", fontWeight: "800", color: "blue", transform: "scale(1.2)" }} />
                        </Dropdown>
                    }
                </div>
                <div onClick={()=>handleOptionSelect("DATA", "LIST")} className={styles.optionSelect} style={(optionSelect?.section === "DATA") ? {textDecoration: "underline", textUnderlineOffset: "2px"} : {}}>Data</div>
            </div>
        </div>
       {
            (optionSelect?.section === "GRAPH") ? (
                optionSelect?.type === "BAR" ? <div style={{width: "100%"}}>
                    <BarChartBos {...barDataFunc("units")} label={"Unit"}/>
                    <BarChartBos {...barDataFunc("gci")} label={"GCI"}/>
                    <BarChartBos {...barDataFunc("volume")} label={"Volume"}/>
                </div> : <div style={{width: "100%"}}>
                    <PieChartBos {...chartDataFunc("units")} label={"Unit"}/>
                    <PieChartBos {...chartDataFunc("gci")} label={"GCI"}/>
                    <PieChartBos {...chartDataFunc("volume")} label={"Volume"}/>
                </div>
            ) : 
            <div className={styles.dataContainer}>
                {
                    (gridDataFunc())?.map((element, idx)=>{

                        return <div className={styles.dataTable} style={(idx) === ((gridDataFunc())?.length-1) ? {borderBottom: "1px solid rgb(191, 191, 191)"} : {}}>
                            <div className={styles.container}>{element?.name}</div>
                            <div>
                                {
                                    element?.values?.map((ele)=>{
                                        return <div>{ele?.name}: {ele.value}</div>
                                    })
                                }
                            </div>
                        </div>
                    })
                }
            </div>
        }
    </div>;
  }
